import "./PatientResources.module.css";
import Navigation from "@/reusable_sections/Header";
import Visit from "./sections/Visit";
import Questions from "./sections/Questions";
import Gallery from "./sections/Gallery";
import Footer from "@/reusable_sections/Footer";
export default function PatientResourcesPage() {
  return <div>
      <Navigation />
      <Visit />
      <Gallery />
      <Questions />
      <Footer />
    </div>;
}